import { ROUTE } from '../../../routes';
import { ACTION } from './types';
import { getDigioForMandate, nextStepCredStepper, removeUrlWithoutReload } from '../../../configs/utils';
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { DigioAgreementStatus, ImportScriptSrc } from "../../../configs/constants";
import { Platform } from "react-native";
let pollInterval;
let hasNavigated = false;
export const goBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER, {});
};
export const initAction = async (action, _datastore, { navigate, network, importScript, showPopup, digio, navigateWithClear, setDatastore, goBack }) => {
    console.warn('*** Init action ***');
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    const delay = action?.payload?.delay;
    setTimeout(async () => {
        importScript(ImportScriptSrc.DIGIO_SCRIPT, getDigioForMandate, async (digio_response) => {
            clearInterval(pollInterval);
            network
                .get(`${api.digioDocsCheckRequestStatusOnCallBack}${applicationId}`, {
                headers: await getAppHeader(),
            })
                .then(async (response) => {
                if (response.status === 200 &&
                    response.data.stepResponseObject ===
                        DigioAgreementStatus.SIGNED) {
                    const routeObj = await nextStepCredStepper();
                    setTimeout(() => {
                        !hasNavigated && navigateWithClear(routeObj.routeId, routeObj.params);
                    }, 3000);
                    const user = await SharedPropsService.getUser();
                    user.linkedApplications[0] =
                        response.data.updatedApplicationObj;
                    await SharedPropsService.setUser(user);
                    await showPopup({
                        type: 'SUCCESS',
                        title: 'Agreement done successfully',
                        ctaLabel: 'Continue',
                        primary: false,
                        ctaAction: {
                            routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                            type: ACTION.SUCCESS_VERIFICATION,
                            payload: {},
                        },
                    });
                }
            });
        }, async (digio_response) => {
            clearInterval(pollInterval);
            if (digio_response?.error === "CANCELLED") {
                await showPopup({
                    type: 'FAILED',
                    title: 'Agreement process cancelled',
                    // subTitle:
                    //     "Interest charges will be deducted automatically every month.",
                    ctaLabel: 'Try again',
                    primary: true,
                    ctaAction: {
                        routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                        type: ACTION.FAILED_VERIFICATION,
                        payload: {},
                    },
                });
            }
            else {
                network
                    .get(`${api.digioDocsCheckRequestStatusOnCallBack}${applicationId}`, {
                    headers: await getAppHeader(),
                })
                    .then(async (response) => {
                    if (response.data.stepResponseObject ===
                        DigioAgreementStatus.REQUESTED) {
                        // do nothing
                    }
                    else if (response.data.stepResponseObject ===
                        DigioAgreementStatus.EXPIRED) {
                        await showPopup({
                            type: 'FAILED',
                            title: 'Something went wrong',
                            // subTitle:
                            //     "Interest charges will be deducted automatically every month.",
                            ctaLabel: 'Try again',
                            primary: true,
                            ctaAction: {
                                routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                                type: ACTION.FAILED_VERIFICATION,
                                payload: {},
                            },
                        });
                    }
                });
            }
        });
        //Digio Agreement
        await network
            .get(`${api.digioDocsInitiateRequest}${applicationId}`, {
            headers: await getAppHeader(),
            handleFromMF: true
        })
            .then(response => {
            if (response.status === 200) {
                if (response.data && response.data.stepResponseObject) {
                    console.log('init: ', response.data);
                    const stepResponseObjectId = response.data.stepResponseObject;
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    //@ts-ignore
                    digio.init();
                    digio.submit(stepResponseObjectId, user.user.phoneNumber);
                    //polling
                    pollInterval = setInterval(async () => {
                        network
                            .get(`${api.digioDocsCheckRequestStatus}${applicationId}`, {
                            headers: await getAppHeader(),
                        }, async () => { return; }, {
                            disableDefault: true
                        })
                            .then(async (res) => {
                            if (res &&
                                res.data &&
                                res.data.stepResponseObject ===
                                    DigioAgreementStatus.SIGNED) {
                                const user = await SharedPropsService.getUser();
                                user.linkedApplications[0] =
                                    response.data.updatedApplicationObj;
                                await SharedPropsService.setUser(user);
                                clearInterval(pollInterval);
                                await showPopup({
                                    type: 'SUCCESS',
                                    title: 'Agreement done successfully',
                                    // subTitle:
                                    //     "Interest charges will be deducted automatically every month.",
                                    ctaLabel: 'Continue',
                                    primary: true,
                                    ctaAction: {
                                        routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                                        type: ACTION.SUCCESS_VERIFICATION,
                                        payload: {},
                                    },
                                });
                            }
                            else if (res &&
                                res.data &&
                                res.data.stepResponseObject ===
                                    DigioAgreementStatus.EXPIRED) {
                                showPopup({
                                    type: 'FAILED',
                                    title: 'Something went wrong',
                                    ctaLabel: 'Try again',
                                    primary: true,
                                    ctaAction: {
                                        routeId: ROUTE.DIGIO_AGREEMENT_SIGN,
                                        type: ACTION.FAILED_VERIFICATION,
                                        payload: {},
                                    },
                                });
                                console.log('Verification Failed');
                                clearInterval(pollInterval);
                            }
                        });
                    }, 5000);
                }
            }
            else if (response?.response?.status === 500) {
                navigate(ROUTE.DIGIO_AGREEMENT_SIGN, {
                    apiFailureCard: true
                });
            }
        })
            .catch(error => {
            console.log(error);
        });
    }, (delay ? delay : 1500));
    await navigate(ROUTE.DIGIO_AGREEMENT_INPROGRESS);
};
export const digioAgreementDeepCallAction = async (action, _datastore, { setDatastore, network }) => {
    const user = await SharedPropsService.getUser();
    const applicationId = user.linkedApplications[0].applicationId;
    network.get(`${api.digioDocsCheckRequestStatusOnCallBack}${applicationId}`, {
        headers: await getAppHeader(),
    })
        .then(async (response) => {
        if (response.status === 200 &&
            response.data.stepResponseObject ===
                DigioAgreementStatus.SIGNED) {
            const user = await SharedPropsService.getUser();
            user.linkedApplications[0] =
                response.data.updatedApplicationObj;
            await SharedPropsService.setUser(user);
            await setDatastore(ROUTE.DIGIO_AGREEMENT_SIGN, 'DigioAgreementPage', {
                digioDeepCheckSuccess: true,
            });
        }
        else {
            if (response.data.stepResponseObject === DigioAgreementStatus.EXPIRED) {
                await setDatastore(ROUTE.DIGIO_AGREEMENT_SIGN, 'DigioAgreementPage', {
                    digioDeepCheckFailure: true,
                });
            }
        }
    });
};
export const initActionForAndroid = async (action, _datastore, { navigate, setDatastore, importScript, network, digio, showPopup }) => {
    await setDatastore(ROUTE.DIGIO_AGREEMENT_SIGN, 'btnItem', {
        loading: true,
    });
    navigate(ROUTE.DIGIO_DOC_MODAL);
};
export const failedVerification = async (action, _datastore, { goBack, hidePopup }) => {
    await hidePopup();
};
export const successVerification = async (action, _datastore, { goBack, navigate }) => {
    hasNavigated = true;
    const routeObj = await nextStepCredStepper();
    await navigate(routeObj.routeId, routeObj.params);
};
export const retryAgreementHidePopup = async (action, _datastore, { goBack, setDatastore }) => {
    await setDatastore(ROUTE.DIGIO_AGREEMENT_SIGN, "DigioAgreementPage", {
        loading: false
    });
    console.warn("*** retryAgreementHidePopup action triggered ***");
};
export const moveToNextStepAction = async (action, _datastore, { goBack, navigate }) => {
    if (Platform.OS === "web") {
        removeUrlWithoutReload("digio_agreement_response");
        removeUrlWithoutReload("status");
        removeUrlWithoutReload("digio_doc_id");
        removeUrlWithoutReload("message");
    }
    const routeObj = await nextStepCredStepper();
    await navigate(routeObj.routeId, routeObj.params);
};
export const contactUs = async (action, _datastore, { navigate }) => {
    console.warn("*** contact us action triggered ***", action);
    await navigate(ROUTE.CONTACT_US_CARD);
};
export const emptyAction = async (action, _datastore, { goBack, setDatastore }) => {
};
